import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { INDEXABLE_ROUTES, getH1 } from '../seo/seoRoutes.mjs';
import './Footer.css';

// Content pages live on the main WordPress domain. Every URL below was verified
// to return 200 — /about/ and /contact/ are 404s there, so they are deliberately
// omitted rather than shipped as sitewide broken links.
const MAIN_SITE = 'https://tarotreadingcard.online';

const Footer = () => {
  const { t, currentLanguage } = useLanguage();

  // English is the canonical bare URL, so only non-English gets a ?lang= suffix.
  // Adding it for 'en' would create a second URL for the canonical page.
  const langSuffix = currentLanguage === 'en' ? '' : `?lang=${currentLanguage}`;

  const spreadRoutes = INDEXABLE_ROUTES.filter((route) => route.path !== '/');

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <nav className="footer-col" aria-labelledby="footer-spreads-heading">
          <h2 id="footer-spreads-heading" className="footer-heading">
            {t('footer.spreadsHeading')}
          </h2>
          <ul>
            {spreadRoutes.map((route) => (
              <li key={route.path}>
                {/* Anchor text is the page's SEO H1 — descriptive anchors are
                    the entire point of this footer for internal linking. */}
                <Link to={`${route.path}${langSuffix}`}>
                  {getH1(route.path, currentLanguage)}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="footer-col" aria-labelledby="footer-learn-heading">
          <h2 id="footer-learn-heading" className="footer-heading">
            {t('footer.learnHeading')}
          </h2>
          <ul>
            <li>
              <a href={`${MAIN_SITE}/tarot-card-meanings/`}>{t('nav.meanings')}</a>
            </li>
            <li>
              <a href={`${MAIN_SITE}/learn-tarot-with-taroca/`}>{t('nav.about')}</a>
            </li>
          </ul>
        </nav>

        <nav className="footer-col" aria-labelledby="footer-company-heading">
          <h2 id="footer-company-heading" className="footer-heading">
            {t('footer.companyHeading')}
          </h2>
          <ul>
            <li>
              <a href={`${MAIN_SITE}/privacy-policy/`}>{t('footer.privacy')}</a>
            </li>
            <li>
              <a href={`${MAIN_SITE}/terms-of-service/`}>{t('footer.terms')}</a>
            </li>
          </ul>
        </nav>
      </div>

      <div className="footer-bottom">
        <p className="footer-disclaimer">{t('footer.disclaimer')}</p>
        <p className="footer-copy">{t('footer.copyright')}</p>
      </div>
    </footer>
  );
};

export default Footer;
